export type GlyphHorizontalBounds = Pick<DOMRect, 'width' | 'x'>;
export type GlyphVerticalBounds = Pick<DOMRect, 'height' | 'y'>;

export const getGlyphHorizontalCenterOffset = (
  bounds: GlyphHorizontalBounds,
  viewportWidth: number,
) => {
  if (!Number.isFinite(bounds.x) || !Number.isFinite(bounds.width) || bounds.width <= 0) {
    return 0;
  }

  return viewportWidth / 2 - (bounds.x + bounds.width / 2);
};

export const getGlyphVerticalCenterOffset = (
  bounds: GlyphVerticalBounds,
  viewportHeight: number,
) => {
  if (!Number.isFinite(bounds.y) || !Number.isFinite(bounds.height) || bounds.height <= 0) {
    return 0;
  }

  return viewportHeight / 2 - (bounds.y + bounds.height / 2);
};
